var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"choose-category"}},[_c('div',{attrs:{"id":"label"}},[_c('p',[_vm._v(_vm._s(_vm.labels.categories.categoriesHeader[_vm.language]))])]),_c('font-awesome-icon',{attrs:{"icon":"utensils"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }